// Şirket bazlı modül kataloğu. Backend bu listeyi doğrulamadan saklar
// (company.enabled_modules) — tek doğru kaynak burasıdır. Yeni bir iş
// kolu eklerken buraya bir satır + Layout.js'teki ilgili nav section'a
// `module` anahtarı eklemek yeterli.
//
// "Ana Sayfa" ve "Admin Paneli" kataloga girmez — her zaman açık (core).
export const MODULE_CATALOG = [
  { key: 'stok', label: 'Stok Yönetimi' },
  { key: 'uretim', label: 'Üretim ve Satış' },
  { key: 'muhasebe', label: 'Muhasebe ve Finans' },
  { key: 'personel', label: 'İnsan Kaynakları' },
  { key: 'insaat', label: 'İnşaat' },
  { key: 'pos_integration', label: 'POS Entegrasyonu' },
];

// Yeni şirket oluştururken varsayılan işaretli modüller — genel amaçlı
// olanlar (her iş kolunda kullanılabilir). Vertikale özel modüller
// (uretim, insaat, pos_integration) admin tarafından bilinçli eklenir.
export const DEFAULT_ENABLED_MODULES = ['stok', 'muhasebe', 'personel'];

// company.enabled_modules alanı YOKSA (eski şirketler, migrasyon
// yapmadık) her modülü açık say — davranış değişmesin. Alan varsa
// (yeni şirketler) sadece listedeki anahtarlar açık.
export function isModuleEnabledFor(company, moduleKey) {
  if (!moduleKey) return true; // core — her zaman açık
  const enabled = company?.enabled_modules;
  if (!Array.isArray(enabled)) return true;
  return enabled.includes(moduleKey);
}
